import { ColoursObj } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode, useEffect, useState } from 'react'
import { Expand } from '../home/components/expand'
import { CountLabel } from './CountLabel'
import { HeaderTitle } from './headerTitle'

interface IHeaderV2Props {
    iconElement: ReactNode
    title: string
    size?: 'small' | 'medium' | 'large'
    textColor?: string
    children?: ReactNode
    open?: boolean
    count?: number
}

export const HeaderV2 = ({
    iconElement,
    title,
    children,
    textColor,
    open,
    count,
}: IHeaderV2Props) => {
    const [positionState, setPositionState] = useState(false)

    useEffect(() => {
        setPositionState(open ?? false) //default to false if open is undefineds
    }, [open])

    return (
        <Stack
            paddingY="16px"
            paddingX="8px"
            borderBottom={'1px solid ' + ColoursObj.shades.shade2}
        >
            {/* Title and arrow flip */}
            <Stack>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    onClick={() => {
                        setPositionState(!positionState)
                    }}
                >
                    <HeaderTitle
                        title={title}
                        iconElement={iconElement}
                        textColor={textColor}
                    />

                    <Stack direction="row" spacing="8px">
                        <CountLabel text={count} />
                        {children !== undefined ? (
                            <>
                                <Box height="24px">
                                    <Expand expanded={positionState} />
                                </Box>
                            </>
                        ) : (
                            <Box width="24px" />
                        )}
                    </Stack>
                </Stack>
            </Stack>

            {/* Children */}
            <AnimatePresence initial={false}>
                {positionState && (
                    <motion.div
                        key={title}
                        layout
                        initial={{ height: 0 }}
                        animate={{ height: 'auto' }}
                        exit={{ height: 0 }}
                        transition={{
                            type: 'spring',
                            duration: 0.4,
                            bounce: 0,
                        }}
                        style={{ overflow: 'clip' }}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </Stack>
    )
}
